import { useMemo } from 'react';

import { useContentfulContentTypeEntry } from '@order/Contentful';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns global Contentful settings for the Order app, such as the notice
 * shared across multiple screens.
 */
export const useGlobalContent = (params: Params = {}) => {
  const { pause } = params;

  const contentfulResponse = useContentfulContentTypeEntry<GlobalContentFields>({
    contentType: GLOBAL_CONTENT_TYPE,
    pause,
  });

  // ─── Derived ─────────────────────────────────────────────────────────────

  const mappedFields = useMemo<MappedGlobalFields>(
    () => ({
      noticeText: contentfulResponse.data?.fields?.globalNoticeText,
      noticePalette: contentfulResponse.data?.fields?.globalNoticePalette,
    }),
    [contentfulResponse.data],
  );

  return {
    fields: mappedFields,
    fetching: contentfulResponse.fetching,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GLOBAL_CONTENT_TYPE = 'global';

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  pause?: boolean;
};

type GlobalContentFields = {
  globalNoticeText?: string;
  globalNoticePalette?: string;
};

type MappedGlobalFields = {
  noticeText: string | undefined;
  noticePalette: string | undefined;
};
